export default {
      id: "sms-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "assets/sprite.svg#sms-usage",
      toString: function () {
        return this.url;
      }
    }


//////////////////
// WEBPACK FOOTER
// ./assets/svg/sms.svg
// module id = ./assets/svg/sms.svg
// module chunks = 0